export function generateSlug(title) {
  if (!title) return '';
  return title
    .toLowerCase()
    .replace(/[çÇ]/g, 'c')
    .replace(/[şŞ]/g, 's')
    .replace(/[ğĞ]/g, 'g')
    .replace(/[üÜ]/g, 'u')
    .replace(/[öÖ]/g, 'o')
    .replace(/[ıİ]/g, 'i')
    .replace(/[^a-z0-9\s-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '')
    .slice(0, 80);
}

export function productUrl(product) {
  const slug = generateSlug(product?.title || '');
  const id = product?.id || product?._id || '';
  return slug ? `/product/${slug}/${id}` : `/product/${id}`;
}
